<template>
  <div class="home">
    <LogoHeader :logo="require('../assets/logo.svg')" :shadow="false"></LogoHeader>
    <Question
      v-for="(question, i) in $store.state.questions"
      :key="i"
      :question="{ id: i+1, ...question }"
      v-show="$store.getters.showSlide('question_'+(i+1))"
      :id="'question_'+(i+1)"
    ></Question>
    <div class="progressbar_wrap">
      <div class="progressbar_inner">
        <div class="progressbar_label">{{ $store.getters.progressPerc }}% COMPLETED</div>
        <div class="progressbar_outer_bar">
          <div class="progressbar_bar" :style="{ width: $store.getters.progressPerc + '%'}"></div>
        </div>
      </div>
    </div>
    <SignAsk
      v-show="$store.getters.showSlide('signAsk')"
      id="signAsk"
    ></SignAsk>
    <Petition v-show="$store.getters.showSlide('petition')" id="petition"></Petition>
    <ShareAsk v-show="$store.getters.showSlide('shareAsk')" id="shareAsk"></ShareAsk>
    <Share v-show="$store.getters.showSlide('share')" id="share"></Share>
    <Donate v-if="$store.getters.showSlide('donate')" id="donate"></Donate>
    <Thanks v-if="$store.getters.showSlide('thanks')" id="thanks"></Thanks>
  </div>
</template>

<script>
import LogoHeader from "../components/generic/LogoHeader";
import Petition from "../slides/Petition";
import Donate from "../slides/Donate";
import Thanks from "../slides/Thanks";
import Share from "../slides/Share";
import SignAsk from "../slides/SignAsk";
import ShareAsk from "../slides/ShareAsk";
import Question from "../slides/Question";

export default {
  name: "handraiser",
  components: {
    LogoHeader,
    Petition,
    Share,
    Thanks,
    Donate,
    SignAsk,
    ShareAsk,
    Question
  },
  mounted() {
    window.$store = this.$store;
    console.log(window.pageCopy)

    if(window.pageCopy) {
      this.$store.commit("addQuestions", window.pageCopy.questions);
      this.$store.commit("addCopy", window.pageCopy);
    }
    // eslint-disable-next-line
    dataLayer.push({'event': 'optimize.activate'});
  },
  updated() {
    // eslint-disable-next-line
    dataLayer.push({'event': 'optimize.activate'});
  }
};
</script>
<style lang="scss" scoped>
.progressbar_wrap {
  background: #ebe6e6;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 69px;
  z-index: 10000000;

  .progressbar_inner {
    max-width: 1000px;
    padding: 0 12px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    // flex-direction: column;
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: flex-start;
    }
    height: 69px;
    .progressbar_label {
      color: #009fe2;
      font-family: "AmnestyTradeGothic";
      font-size: 20px;
      // margin-bottom: 10px;
      height: 18px;
      line-height: 1;
      min-width: 160px;
      @media (max-width: 767px) {
        margin-bottom: 10px;
      }
    }

    .progressbar_outer_bar {
      height: 12px;
      background: #c5c5c4;
      width: 100%;
      // border-radius: 6px;
      .progressbar_bar {
        height: 12px;
        background: #009fe2;
        // border-radius: 6px;
        transition: 1s;
      }
    }
  }
}
</style>
